export const NEXT_TEXT = "Next";
export const BACK_TEXT = "Back";
export const FINISH_TEXT = "Finish";
